// 全局联系表单状态管理
let contactModalController: {
  openModal: (config?: ContactModalConfig) => void
  closeModal: () => void
} | null = null

export interface ContactModalConfig {
  subject?: string
  message?: string
  source?: string
}

// 注册联系表单控制器
export const registerContactModal = (controller: {
  openModal: (config?: ContactModalConfig) => void
  closeModal: () => void
}) => {
  contactModalController = controller
}

// 打开联系表单模态框
export const openContactForm = (config: ContactModalConfig = {}) => {
  if (contactModalController) {
    contactModalController.openModal(config)
  } else {
    console.warn('Contact modal not registered. Using fallback.')
    // 备用方案：如果模态框未注册，使用传统的mailto
    const subject = encodeURIComponent(config.subject || 'General Inquiry - MiJin Technology')
    const body = encodeURIComponent(config.message || 'Hello,\n\nI am interested in your smart library solutions.')
    window.location.href = `mailto:rfidlib@libmj.com?subject=${subject}&body=${body}`
  }
}

// 替换原有的emailUtils函数
export const contactUtils = {
  // 免费咨询
  openConsultationForm: (source: string = 'consultation') => {
    openContactForm({
      subject: 'Free Consultation Request - Smart Library Solutions',
      message: `Dear MiJin Technology Team,

I hope this email finds you well. I am deeply interested in your smart library solutions and would like to apply for consultation services to explore potential collaboration opportunities.

Consultation Purpose:
Please describe your specific needs and objectives in detail below:

`,
      source: source
    })
  },

  // 产品咨询
  openProductInquiry: (productName: string, productDescription: string, source: string = 'product') => {
    openContactForm({
      subject: `Product Inquiry - ${productName}`,
      message: `Dear MiJin Technology Team,

I am interested in learning more about your product: ${productName}

Product Description: ${productDescription}

Please provide me with:
- Detailed specifications
- Pricing information
- Implementation timeline
- Case studies or references

Additional Requirements:
`,
      source: source
    })
  },

  // 一般咨询
  openGeneralInquiry: (customSubject?: string, source: string = 'general') => {
    openContactForm({
      subject: customSubject || 'General Inquiry - Smart Library Solutions',
      message: `Dear MiJin Technology Team,

I would like to inquire about your smart library solutions.

Please provide information about:
- Your product portfolio
- Services offered
- Pricing options
- Partnership opportunities

`,
      source: source
    })
  },

  // 手册下载
  openBrochureRequest: (productName?: string, source: string = 'brochure') => {
    openContactForm({
      subject: 'Product Brochure Request - Smart Library Solutions',
      message: `Dear MiJin Technology Team,

I would like to request the product brochure and technical specifications for your smart library solutions.

${productName ? `Specifically interested in: ${productName}\n\n` : ''}Please send me information about:
- Complete product catalog
- Technical specifications
- Case studies
- Pricing information

`,
      source: source
    })
  },

  // 新闻详情
  openNewsInquiry: (newsTitle: string, newsId: string, source: string = 'news') => {
    openContactForm({
      subject: 'More Information Request - News Article',
      message: `Dear MiJin Technology Team,

I read your news article "${newsTitle}" and would like to learn more about this topic.

Article ID: ${newsId}

Please provide additional information about:
- Technical details
- Implementation process
- Related products or services
- Future developments

`,
      source: source
    })
  },

  // 直接邮箱联系（用于显示邮箱地址的地方）
  openDirectContact: (source: string = 'direct') => {
    openContactForm({
      subject: 'Contact Request - MiJin Technology',
      message: `Dear MiJin Technology Team,

I would like to get in touch regarding your smart library solutions.

`,
      source: source
    })
  }
}

// 导出兼容的emailUtils，逐步替换原有功能
export const emailUtils = {
  // 保持与原有API的兼容性
  openConsultationEmail: (_t?: any) => contactUtils.openConsultationForm('consultation_button'),
  openProductInquiryEmail: (_t: any, productName: string, productDescription: string) => 
    contactUtils.openProductInquiry(productName, productDescription, 'product_card'),
  openGeneralEmail: (_t: any, customSubject?: string) => 
    contactUtils.openGeneralInquiry(customSubject, 'general_button'),
  openBrochureEmail: (_t: any, productName?: string) => 
    contactUtils.openBrochureRequest(productName, 'brochure_button'),
  openNewsReadMoreEmail: (_t: any, newsTitle: string, newsId: string) => 
    contactUtils.openNewsInquiry(newsTitle, newsId, 'news_article'),
  openDirectEmail: (_email?: string) => 
    contactUtils.openDirectContact('email_link'),
    
  // 保留原有的备用功能
  copyEmailToClipboard: (email: string = 'rfidlib@libmj.com') => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(email).then(() => {
        alert(`✅ 邮箱地址已复制！\n${email}\n\n请在您的邮件应用中粘贴发送邮件。`)
      }).catch(() => {
        alert(`请手动复制邮箱地址: ${email}`)
      })
    } else {
      alert(`请手动复制邮箱地址: ${email}`)
    }
  },
  
  showEmailFallbackOptions: (email: string = 'rfidlib@libmj.com') => {
    const useForm = confirm(
      `无法打开邮件客户端？\n\n` +
      `点击"确定"使用联系表单（推荐）\n` +
      `点击"取消"复制邮箱地址: ${email}`
    )
    
    if (useForm) {
      contactUtils.openDirectContact('fallback_form')
    } else {
      emailUtils.copyEmailToClipboard(email)
    }
  }
}
